import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { site, nav, materialsNav } from "../../data/site";

const Footer = () => {
  const primaryLinks = nav.filter((l) =>
    ["Services", "Materials", "Gallery", "Our Process", "Commercial", "About", "FAQ", "Contact"].includes(l.name)
  );

  return (
    <footer className="bg-[#1A3D84] text-white" data-testid="site-footer">
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-5">
              <img src={site.logoDark} alt="Premier Granite LLC" className="h-24 w-auto rounded" />
            </Link>
            <p className="font-display text-xl text-white/90 leading-snug mb-6">
              Craftsmanship Built to Last.<br />Excellence Set in Stone.
            </p>
            <p className="text-sm text-white/60 flex items-start gap-2">
              <MapPin size={15} className="mt-0.5 shrink-0" />
              Serving the {site.serviceArea}
            </p>
          </div>

          {/* Explore */}
          <div>
            <h4 className="text-xs font-semibold tracking-widest uppercase text-white/70 mb-5">Explore</h4>
            <ul className="space-y-3">
              {primaryLinks.map((l) => (
                <li key={l.name}>
                  <Link to={l.path} className="text-sm text-white/80 hover:text-white transition-colors">
                    {l.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Materials */}
          <div>
            <h4 className="text-xs font-semibold tracking-widest uppercase text-white/70 mb-5">Materials</h4>
            <ul className="space-y-3">
              {materialsNav.map((m) => (
                <li key={m.name}>
                  <Link to={m.path} className="text-sm text-white/80 hover:text-white transition-colors">
                    {m.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs font-semibold tracking-widest uppercase text-white/70 mb-5">Get In Touch</h4>
            <div className="space-y-4">
              <a href={site.phoneHref} className="flex items-center gap-3 text-sm text-white/80 hover:text-white transition-colors">
                <Phone size={15} className="text-[#CD1422]" /> {site.phone}
              </a>
              <a href={site.emailHref} className="flex items-center gap-3 text-sm text-white/80 hover:text-white transition-colors break-all">
                <Mail size={15} className="text-[#CD1422]" /> {site.email}
              </a>
              <Link to="/contact" className="btn btn-primary w-full mt-2">Get a Free Estimate</Link>
            </div>
          </div>
        </div>

        <div className="border-t border-white/15 mt-12 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-white/60">
            © {new Date().getFullYear()} {site.name}. All Rights Reserved.
          </p>
          <div className="flex items-center gap-6 text-xs text-white/60">
            <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white transition-colors">Terms of Use</Link>
            <a href={`https://${site.domain}`} className="hover:text-white transition-colors">{site.domain}</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
